<template>
  <Dialog :visible="confirmDialogVisibility" :modal="true" :style="{ width: auto }" :closable="false" >
        <div class="flex justify-content-between flex-wrap">
            <div class="flex align-items-center justify-content-center text-xl font-semibold">
                <label>{{confirmDialogHeader}}</label>
            </div>
            <div class="flex align-items-center justify-content-center">
                <div class="field grid">
                    <label class="col-fixed" >Year: {{dialogServicingYear}} | Quarter: {{dialogServicingQtr}}</label>
                    <div class="col">
                    
                    </div>
                </div>
            </div>                      

        </div>
        <hr>             
        <div class="field font-medium text-lg my-2 w-full">
            <label >Servicing details</label> <span class="text-sm text-400">Options marked as <span class="text-red-500">*</span> are mandatory</span>
        </div>
        <div class="field">
            <label class="font-medium">Centre Name:<span class="text-red-500">*</span></label>
            <InputText class="w-full " v-model="cmcCentre" placeholder="Health facility where equipment servicing was performed"/>
        </div>
        <div class="formgrid grid">
            <div class="field col">
                <label class="font-medium">Contact No.:</label>
                <InputText class="w-full " v-model="centreContact"/>
            </div>
            <div class="field col">
                <label class="font-medium">Department:<span class="text-red-500">*</span></label>
                <InputText class="w-full " v-model="cmcDept"/>
            </div>
        </div>
        <div class="formgrid grid">
            <div class="field col">
                <label class="font-medium">User:<span class="text-red-500">*</span></label>
                <InputText class="w-full " v-model="cmcUser"/>
            </div>
            <div class="field col">
                <label class="font-medium" >Designation:<span class="text-red-500">*</span></label>
                <InputText class="w-full " v-model="userDesignation" placeholder="Designation of user"/>
            </div>
        </div>

        <div class="formgrid grid">
            <div class="field col w-full">
                <label class="font-medium">Service type:<span class="text-red-500">*</span></label>
                <SelectButton v-model="serviceType" optionLabel="name" :options="serviceTypeOptions" aria-labelledby="basic" disabled />
            </div>
            <div class="field col">
                <label class="font-medium">Servicing duration:</label>
                <div class="flex">
                    <Calendar v-model="startDate" class="w-full " placeholder="Start date " dateFormat="dd/mm/yy"/>
                    <Calendar v-model="endDate" class="w-full " placeholder="End date" dateFormat="dd/mm/yy"/>

                </div>
                <!-- <div> -->
                    <!-- <Calendar v-model="cmcDurationDate" selectionMode="range" class="w-full " placeholder="Start date - End date" /> -->
                <!-- </div>
                <div>
                </div> -->
            </div>
            <div class="field col">
                <label class="font-medium">Engineer:<span class="text-red-500">*</span></label>
                <Dropdown editable class="w-full" v-model="servicingEngineer" :options="engineers" optionValue="id" optionLabel="name" placeholder="Select engineer"/>
            </div>
        </div>

        <div class="field col">
            <label class="font-medium">Action taken:<span class="text-red-500">*</span></label>
            <Textarea v-model="cmcAction" rows="4" class="w-full " placeholder="Enter servicing details here..." />
        </div>

        <template #footer>
            <div class="flex justify-content-end flex-wrap">
            <Button class="my-1 mr-2 py-2" :label="btnText" severity="success" text raised @click="updateCmc"/>
            <Button class="flex align-items-center justify-content-center my-1" size="small" label="No" text raised severity="secondary" @click="closeDialog"></Button>
            </div>
        </template>

        </Dialog>
</template>

<script>
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import SelectButton from 'primevue/selectbutton';
import Textarea from 'primevue/textarea';
import { fetchInstallationEngineers, updateServicings } from '@/services/apiService';

export default {
    name:'ServicingComponent',
    
    props:{
        cmcData:Object,
        visibility:Boolean,
        btnOption:String,
    },
    
    components:{
        Dialog,
        InputText,
        Button,
        Textarea,
        SelectButton,
        Calendar,
        Dropdown,
    },
    data(){
        return{
            confirmDialogVisibility:this.visibility,
            confirmDialogHeader:null,
            serviceTypeOptions:[
                { name:'Breakdown', value:1},
                { name:'Primitive', value:2},
                { name:'Annual', value:3},
            ],
            engineers:[],
            dialogServicingYear:this.cmcData.year,
            dialogServicingQtr:this.cmcData.quarter,
            cmcCentre:this.cmcData.centre,
            centreContact:this.cmcData.centreContact,
            cmcDept:this.cmcData.department,
            cmcUser:this.cmcData.cmcUser,     
            userDesignation:this.cmcData.cmcUserDesignation,
            serviceType:null,
            startDate:this.cmcData.startDate,
            endDate:this.cmcData.endDate,
            servicingEngineer:this.cmcData.cmcEngineer,
            cmcAction:this.cmcData.cmcAction,
            btnText:this.btnOption,
        }
    },
    mounted(){    
       this.confirmDialogHeader = this.cmcData.item
       fetchInstallationEngineers().then((res)=>{
            this.engineers = res.data;
        }).catch((error)=>{
            this.showErrorToast(error.response.data);
        })
        this.getServiceType();
        this.startDate = this.getJsDate(this.cmcData.startDate);
        
        this.endDate = this.getJsDate(this.cmcData.endDate);
        
    },  
    unmounted(){
        this.confirmDialogVisibility = false;
    }, 
    methods:{
        closeDialog(){
            this.confirmDialogVisibility = false;
            this.$emit('close-cmc-dialog', this.confirmDialogVisibility);
        },
        getServiceType(){            
            this.serviceType = this.serviceTypeOptions.find((e)=> e.name===this.cmcData.serviceType);
        },
        getJsDate(date){             
            let date2 = null;
            if(date!=null){                
                var date1 = date.split("-");    
                date2 = new Date(date1[2], (date1[1]-1), date1[0]);
            }
            return date2;
        },
        updateCmc(){

            if(typeof(this.servicingEngineer)=='string'){
                this.servicingEngineer = this.engineers.find((e)=> e.name===this.servicingEngineer).id;
            }            

            if(this.startDate==null){
                return this.showErrorToast({message:'Start Date of CMC is required!'});
            }

            if(this.startDate!=null && this.endDate==null){
                this.endDate = this.startDate;
            }            
            
            const data = {
                selectedService:null,
                equipmentId:this.cmcData.equipmentId,
                // cmcId:this.cmcData.id,
                cmcCentre: this.cmcCentre,
                cmcCentreContact: this.centreContact,
                cmcDept: this.cmcDept,
                cmcUser: this.cmcUser,
                cmcUserDesignation: this.userDesignation,
                cmcServiceType: this.serviceType.value,
                cmcStartDate: this.startDate!=null ? this.startDate.getDate()+'-'+(this.startDate.getMonth()+1)+'-'+this.startDate.getFullYear() : null,
                cmcEndDate: this.endDate!=null ? this.endDate.getDate()+'-'+(this.endDate.getMonth()+1)+'-'+this.endDate.getFullYear() : null,
                cmcEngineer: this.servicingEngineer,
                cmcAction: this.cmcAction,
                }

            updateServicings(data, this.cmcData.id).then((res)=>{
                this.showSuccessToast(res.data);
                this.closeDialog();                
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
            })
            
        }, 
        showSuccessToast(data){
            this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 2500 });
        }, 
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 2500 });
        },  
    }
    
}
</script>

<style>

</style>